import React, {useEffect, useRef} from 'react';
import {AiAssistantConversation, HibuAssistantMessage} from './types';
import {ConditionalRender} from '../../common/conditional-render/ConditionalRender';
import {ChatMessage} from './chatMessage';
import {ChatSuggestions} from './chatSuggestions';

export type ChatWindowProps = {
    conversation: AiAssistantConversation | undefined;
    currentMessage?: HibuAssistantMessage;
    suggestionsEnabled?: boolean;
    updateConversationForSuggestions?: (v: string) => Promise<void>;
    renderSources?: boolean;
};
export const ChatWindow = ({
                               conversation,
                               currentMessage,
                               suggestionsEnabled,
                               updateConversationForSuggestions,
                               renderSources,
                           }: ChatWindowProps): React.JSX.Element | null => {
    const conversationRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Use a small timeout to ensure DOM has updated
        const timeoutId = setTimeout(() => {
            if (conversationRef.current) {
                conversationRef.current.scrollIntoView({behavior: 'smooth', block: 'end'});
            }
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [conversation]);

    if (!conversation) {
        return null;
    }

    return (
        <div className="chat-window-container">
            <div className="chat-window" ref={conversationRef}>
                {conversation.conversationMessages.map((msg: HibuAssistantMessage, index: number) => (
                    <ConditionalRender
                        key={'chat-message-' + index}
                        shouldRender={!!msg.text}
                        children={<ChatMessage msg={msg} index={index} shouldRenderSources={renderSources}/>}
                    />
                ))}
                {currentMessage && currentMessage.text && (
                    <ChatMessage index={999} msg={currentMessage} shouldRenderSources={renderSources}/>
                )}
                <ConditionalRender
                    shouldRender={!!suggestionsEnabled && !!updateConversationForSuggestions}
                    children={
                        <ChatSuggestions
                            suggestions={conversation.suggestions}
                            updateConversation={updateConversationForSuggestions}
                        />
                    }
                />
            </div>
        </div>
    );
};
